import React from 'react';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';

export interface ICrProgressIndicatorProps {
    hidden: boolean;
    label?: string;
    description?: string;
    barHeight?: number;
}

export const CrProgressIndicator = ({ barHeight, hidden, label, description }: ICrProgressIndicatorProps): React.ReactElement => {
    if (hidden === true) return null;
    return (
        <div style={{ marginTop: '10px', marginBottom: '30px' }}>
            <ProgressIndicator
                label={label}
                description={description}
                barHeight={barHeight ?? 2}
            />
        </div>
    );
};
